import ControllerFeatures from './ControllerFeatures';
import ControllerStickyReels from './ControllerStickyReels';
import ControllerSymbolsProvider from './ControllerSymbolsProvider';
import GlobalDispatcher from 'Engine/events/GlobalDispatcher';
import eEventTypes from '../../enums/eEventTypes';
import EntryPoint from 'Engine/EntryPoint';
import BonusLabelsGenerator from './ControllerBonusLabelsGenerator';
import SoundManager from 'Engine/soundManager/SoundManager';
import { eSounds } from '../../enums/eSounds';

export default class ControllerBonusFeatures extends ControllerFeatures {
  constructor({ reelsContainer, controllerReels, controllerReelsBackground }) {
    super({ reelsContainer, controllerReels, controllerReelsBackground });
  }

  init() {
    this.ControllerStickyReels = new ControllerStickyReels({
      containerReels: this.topContainer,
      controllerReels: this.ControllerReels
    });
    this.ControllerLabelsProvider = new ControllerSymbolsProvider({
      controllerReels: this.ControllerReels,
      callback: this.provideSymbolLabel.bind(this),
      symbolId: EntryPoint.GameModel.availableBonusSymbolIds,
    });
    this.ControllerJackpotSymbolsProvider = new ControllerSymbolsProvider({
      controllerReels: this.ControllerReels,
      callback: this.openJackpotBox.bind(this),
      symbolId: EntryPoint.GameModel.jackpotCoeffs,
      delay: 500,
    });
    // this.bonusLabelsGenerator = new BonusLabelsGenerator();
  }

  addListeners() {
    GlobalDispatcher.add(eEventTypes.EET_START_SCREEN__STATE__START, this._restoreField.bind(this));
    GlobalDispatcher.add(eEventTypes.EET_WIN_COLLECT__START, this.startCollect.bind(this));
    GlobalDispatcher.add(eEventTypes.EET_WIN_COLLECT__END, this.stopCollect.bind(this));
    GlobalDispatcher.add(eEventTypes.EET_OPEN_JACKPOT_BOXES__START, this.startOpenBoxes.bind(this));
    GlobalDispatcher.add(eEventTypes.EET_OPEN_JACKPOT_BOXES__END, this.stopOpenBoxes.bind(this));
    GlobalDispatcher.add(eEventTypes.EET_RESET_BONUS_FIELD__START, this.resetField.bind(this));
  }

  onStart() {
    this.ControllerStickyReels.onStart();
  }

  onReelHitBar(reelIndex) {
    this.ControllerStickyReels.tryToActivateSymbol(reelIndex);
  }

  onAllReelsStopped() {
    this.ControllerStickyReels.checkReelsForExclude();
  }

  onEnd() {
    this.ControllerStickyReels.reset();
  }

  startCollect() {
    this.ControllerLabelsProvider.start();
  }

  stopCollect() {
    this.ControllerLabelsProvider.stop();
  }

  startOpenBoxes() {
    this.ControllerJackpotSymbolsProvider.start();
  }

  stopOpenBoxes() {
    this.ControllerJackpotSymbolsProvider.stop();
  }

  onCycleAvailableSymbol(...args) {
    // this.bonusLabelsGenerator.setLabel(...args);
  }

  showWin(data) {
  }

  resetField() {
    this.ControllerStickyReels.reset();
    this.ControllerJackpotSymbolsProvider.exceptions = [];
    GlobalDispatcher.dispatch(eEventTypes.EET_RESET_BONUS_FIELD__COMPLETE);
  }

  provideSymbolLabel(data) {
    GlobalDispatcher.dispatch(eEventTypes.EET_THROW_LABEL, data)
  }

  openJackpotBox({ symbol, complete }) {
    this.ControllerJackpotSymbolsProvider.exceptions.push(symbol);
    symbol.startAnimation();
    SoundManager.play(eSounds.EST_OPEN_BOX.soundName, eSounds.EST_OPEN_BOX.volume, false, eSounds.EST_OPEN_BOX.group);
    if (complete) {
      symbol.once('animationComplete', () => GlobalDispatcher.dispatch(eEventTypes.EET_OPEN_JACKPOT_BOXES__COMPLETE));
    }
  }

  _restoreField() {
    if (!EntryPoint.GameModel.isFreeSpinsMode) return;

    for (let reelIndex = 0; reelIndex < this.ControllerReels.reels.length; reelIndex++) {
      for (let symbolIndex = this.ControllerReels.topSimbolsCount; symbolIndex < this.ControllerReels.reels[reelIndex].symbols.length - this.ControllerReels.bottomSimbolsCount; symbolIndex++) {
        const symbol = this.ControllerReels.reels[reelIndex].symbols[symbolIndex];
        if (EntryPoint.GameModel.jackpotCoeffs.includes(symbol.id)) {
          symbol.startIdleAnimation();
          this.ControllerJackpotSymbolsProvider.exceptions.push(symbol);
        }
      }
    }
  }
}
